import React from "react"
import { StyleSheet, Text } from "react-native"
import { theme } from "@common/theme/theme"
import withPreventDoubleClick from "@common/utils/withPreventDoubleClick"

/**
 * « Modifier », en bleu, au bout de ce qu'il change. Le mot, pas un crayon :
 * un parent le lit sans avoir à deviner qu'une valeur soulignée se touche.
 * La garde contre le double appui évite d'ouvrir le choix pour le refermer
 * aussitôt. `label` nomme ce qu'il modifie, pour un lecteur d'écran.
 */
const EditLink = withPreventDoubleClick(({ label, onPress }) => (
    <Text
        style={styles.link}
        onPress={onPress}
        accessibilityRole="button"
        accessibilityLabel={`${label} : modifier`}
    >
        Modifier
    </Text>
))

const styles = StyleSheet.create({
    link: {
        fontFamily: "Montserrat-Medium",
        fontSize: 13,
        lineHeight: 20,
        color: theme.colors.primary,
    },
})

export default EditLink
